import { useMemo, useState } from "react"
import { useTable } from "react-table"
import { ImgsODS } from "../NewODS"
import { BadgeEsm } from "../Badge"
import { getType } from "../../screen/ESMScreen"
import { UseOdsArea } from "../../core/utils/hooks/useOdsArea"
import { Button } from "../Button"
import moment from "moment"
import "./styles.scss"
import { Esm5w2hAction } from "../Esm5w2hAction"

export const ODSContainer = ({ row }) => {
  const response = UseOdsArea(row.values.area, row.values.ods)
  const ods = response.ods.map((ods) => ods)
  const arrOdsNumber = ods.map((str) => str.replace(/\D+/g, " ").trim())

  return (
    <div className="ods-esm-cell">
      {arrOdsNumber.splice(0, 4).map((number, index) => {
        return (
          <>
            <div id={`card${index + 1}`} class="card-plan" title={ods}>
              <ImgsODS type={number} />
            </div>
          </>
        )
      })}
    </div>
  )
}

export const ActionDetailsContainer = ({ value, name, row, ...props }, setIs5w2hModalOpen) => {
  return (
    <>
      <div className="action-details-cell">
        <small onClick={() => setIs5w2hModalOpen(value)}>
          Ver detalhes
        </small>
      </div>
    </>
  )
}

export const BadgeEsmContainer = ({ value, name, row, ...props }) => {
  return (
    <>
      <div className="badge-esm-cell">
        <BadgeEsm label={value} type={getType(value)} />
      </div>
    </>
  )
}

export const CompleteButton = ({ isComplete, handleChangeIsComplete }) => {
  return <div className="complete-button__container">
    {
      isComplete ? (
        <span>{moment(isComplete).format('DD/MM/YYYY')}</span>
      ) : (
        <Button
          color="secondary" // secondary-orange
          label="Concluir"
          handleClick={handleChangeIsComplete}
        />
      )
    }
  </div>
}

export const EsmPlanList = ({ actionList, isFromCommunity = false }) => {
  const [is5w2hModalOpen, setIs5w2hModalOpen] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: "ODS",
        accessor: "ods",
        Cell: (value) => ODSContainer(value),
      },
      {
        Header: "Ação",
        accessor: "title",
      },
      {
        Header: "Área",
        accessor: "area",
      },
      {
        Header: "Como será feita?",
        accessor: "actionProducer",
        Cell: (value) => ActionDetailsContainer(value, setIs5w2hModalOpen),
      },
      {
        Header: "Nível",
        accessor: "level",
        Cell: (value) => BadgeEsmContainer(value),
      },
      {
        Header: "Conclusão",
        accessor: "isComplete",
        Cell: (value) => (
          <CompleteButton
            isComplete={value?.row?.values?.isComplete}
            handleChangeIsComplete={value?.row?.original?.handleChangeIsComplete}
          />
        ),
      },
    ],
    [actionList],
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: useMemo(() => actionList, [actionList]),
  })

  return (
    <div className="table-esm-plan">
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()} className="esm-plan-list-row">
                {row.cells.map((cell) => {
                  return <td {...cell.getCellProps()}>{cell.render("Cell")} </td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {is5w2hModalOpen &&
        <Esm5w2hAction
          action={{ actionId: is5w2hModalOpen }}
          handleCloseModal={() => setIs5w2hModalOpen(false)}
          isFromCommunity={isFromCommunity}
        />
      }
    </div>
  )
}
